import { render, staticRenderFns } from "./ParesSection.vue?vue&type=template&id=636906ad&scoped=true&"
import script from "./ParesSection.vue?vue&type=script&lang=js&"
export * from "./ParesSection.vue?vue&type=script&lang=js&"
import style0 from "./ParesSection.vue?vue&type=style&index=0&id=636906ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636906ad",
  null
  
)

export default component.exports